import React, { useState } from "react";
import PropTypes from "prop-types";
import Modal from "shared/components/Modal";
import PhoneVerificationFlow from "shared/containers/PhoneVerificationFlow";
import useUpdatePhone from "shared/hooks/useUpdatePhone";
import LandingScreen from "./LandingScreen";
import { LANDING_SCREEN_VARIANTS } from "./constants";

import "./index.scss";

if (process.env.PLATFORM === "mobile") {
	require("./index.mobile.scss");
}

const STEPS = {
	LANDING: "LANDING",
	PHONE_FLOW: "PHONE_FLOW",
};

const SUCCESS_SCREEN_TIMEOUT = 2000;

function SmsMigrationModal({ show, onCancel, handleSuccess, landingScreenVariant }) {
	const [step, setStep] = useState(STEPS.LANDING);
	const successCallback = () => setTimeout(handleSuccess, SUCCESS_SCREEN_TIMEOUT);
	const handlePhoneVerified = useUpdatePhone(successCallback);

	return (
		<Modal
			className="sms-migration-modal"
			show={show}
			onCancel={onCancel}
			willCloseOnClick
		>
			<div className="signin-modal-content">
				{step === STEPS.LANDING && (
					<LandingScreen
						variant={landingScreenVariant}
						handleEnterPhoneClick={() => setStep(STEPS.PHONE_FLOW)} />
				)}
				{step === STEPS.PHONE_FLOW && (
					<PhoneVerificationFlow handlePhoneVerified={handlePhoneVerified} />
				)}
			</div>
		</Modal>
	);
}

SmsMigrationModal.propTypes = {
	show: PropTypes.bool.isRequired,
	onCancel: PropTypes.func.isRequired,
	handleSuccess: PropTypes.func.isRequired,
	landingScreenVariant: PropTypes.oneOf(Object.values(LANDING_SCREEN_VARIANTS)).isRequired,
};

export default SmsMigrationModal;



// WEBPACK FOOTER //
// ./src/shared/components/SmsMigrationModal/index.jsx